export default "__VITE_ASSET__7c03735e__"